import { IXetThucTapRequest } from "../../model/request/xet-thuc-tap/IXetThucTapRequest";
import { IXetThucTapThamSoXetRequest } from "../../model/request/xet-thuc-tap/IXetThucTapThamSoXetRequest";
import { apiClient } from "../apiClient";

const XET_THUC_TAP_ENDPOINT = 'xet-thuc-tap';
export const xetThucTapApi = {
    Xet: (request: IXetThucTapThamSoXetRequest) => apiClient.post(`${XET_THUC_TAP_ENDPOINT}/xet/${request.id_dot_thuc_tap}?progress_id=${request.progress_id}`, request),
    XetTheoMonNghiepVu: (request: IXetThucTapRequest) => apiClient.post(`${XET_THUC_TAP_ENDPOINT}/xet-theo-mon-nghiep-vu/${request.id_dot_thuc_tap}?progress_id=${request.progress_id}`, request),
}